import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Default, Expose, Model, ModelId } from '@core/shared/model';
let CreateResetTokenResponse = /*#__PURE__*/(() => {
  let CreateResetTokenResponse = class CreateResetTokenResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", String)], CreateResetTokenResponse.prototype, "token", void 0);
  CreateResetTokenResponse = __decorate([ModelId("CreateResetTokenResponse") // auto-generated by generate-model-ids
  ], CreateResetTokenResponse);
  return CreateResetTokenResponse;
})();
export { CreateResetTokenResponse };
let CreateResetTokenRequest = /*#__PURE__*/(() => {
  let CreateResetTokenRequest = class CreateResetTokenRequest extends Model {
    static {
      this.Response = CreateResetTokenResponse;
    }
  };
  CreateResetTokenRequest = __decorate([AppRequest('users', 'password-reset/create-token', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['managedCompany']
  }), ModelId("CreateResetTokenRequest") // auto-generated by generate-model-ids
  ], CreateResetTokenRequest);
  return CreateResetTokenRequest;
})();
export { CreateResetTokenRequest };
let ValidateResetTokenResponse = /*#__PURE__*/(() => {
  let ValidateResetTokenResponse = class ValidateResetTokenResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Function)], ValidateResetTokenResponse.prototype, "isValid", void 0);
  __decorate([Expose(), __metadata("design:type", String)], ValidateResetTokenResponse.prototype, "message", void 0);
  ValidateResetTokenResponse = __decorate([ModelId("ValidateResetTokenResponse") // auto-generated by generate-model-ids
  ], ValidateResetTokenResponse);
  return ValidateResetTokenResponse;
})();
export { ValidateResetTokenResponse };
let ValidateResetTokenRequest = /*#__PURE__*/(() => {
  let ValidateResetTokenRequest = class ValidateResetTokenRequest extends Model {
    static {
      this.Response = ValidateResetTokenResponse;
    }
  };
  __decorate([Expose(), __metadata("design:type", String)], ValidateResetTokenRequest.prototype, "token", void 0);
  ValidateResetTokenRequest = __decorate([AppRequest('users', 'password-reset/validate-token', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("ValidateResetTokenRequest") // auto-generated by generate-model-ids
  ], ValidateResetTokenRequest);
  return ValidateResetTokenRequest;
})();
export { ValidateResetTokenRequest };
let CreateResetTokenQRCodeRequest = /*#__PURE__*/(() => {
  let CreateResetTokenQRCodeRequest = class CreateResetTokenQRCodeRequest extends Model {};
  __decorate([Expose(), Default('img'), __metadata("design:type", String)], CreateResetTokenQRCodeRequest.prototype, "format", void 0);
  CreateResetTokenQRCodeRequest = __decorate([AppRequest('users', 'password-reset/create-token/qrcode', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['managedCompany'],
    disallowInternal: true
  }), ModelId("CreateResetTokenQRCodeRequest") // auto-generated by generate-model-ids
  ], CreateResetTokenQRCodeRequest);
  return CreateResetTokenQRCodeRequest;
})();
export { CreateResetTokenQRCodeRequest };